// Generated by BUCKLESCRIPT VERSION 6.0.0, PLEASE EDIT WITH CARE
'use strict';

var App = require("./app");
var React = require("react");
var ReactDOMRe = require("reason-react/lib/js/src/ReactDOMRe.js");

require("./index.css");

function init(param) {
  document.addEventListener("keydown", (function (evt) {
          return ReactDOMRe.renderToElementWithId(React.createElement(App.make, {
                          evt: evt
                        }), "root");
        }));
  return /* () */0;
}

init(/* () */0);

ReactDOMRe.renderToElementWithId(React.createElement(App.make, { }), "root");

exports.init = init;
/*  Not a pure module */
